import { METRIC_NAME } from '@/constants/index.ts';
import { monitorSingleJsLoadTime } from '@/utils/index.ts';
import { asyncLoadFile } from '@/utils/asyncLoadFile.ts';
import { v4 as uuidv4 } from 'uuid';
import { smartReport } from '@/utils/metricHelper.ts';

let riskifiedDeviceId = '';
export async function entry(data: typeof import('@/constants')['DEFAULT_ANTI_SPIDER']['riskified']) {
    const { url } = data
    riskifiedDeviceId = uuidv4();
    window.__riskifiedDeviceId = riskifiedDeviceId
    loadScript(`${url}&sid=${riskifiedDeviceId}`);
}

const loadScript = (url: string) => {
    asyncLoadFile({
        label: 'script',
        attrs: {
            async: 'true',
            src: url
        },
    }).then(() => {
        smartReport({
            metric_name: METRIC_NAME,
            tags: { url, type: 'loadRiskified' },
            value: 1,
            message: 'riskified load success',
        })
    }).then(() => {
        monitorSingleJsLoadTime(riskifiedDeviceId, 'beacon.riskified.com', 'riskified');
    })
        .catch(error => {
            smartReport({
                metric_name: METRIC_NAME,
                tags: { url, type: 'loadRiskifiedError' },
                value: 1,
                message: 'riskified load error',
                params: error
            })
        })
}
export function provideRiskifiedDeviceId() {
    return riskifiedDeviceId || ''
}